import { useCallback, useEffect, useState, type ReactNode } from 'react';
import Check from '@/assets/icons/Check.svg';
import * as Styled from './DiscountCardDisclosure.styled';

interface DiscountCardDisclosureProps {
  children: ReactNode;
  icon: ReactNode;
  isExpanded?: boolean;
  label: string;
  onExpand?: () => void;
}

export const DiscountCardDisclosure = ({
  children,
  icon,
  isExpanded = false,
  label,
  onExpand,
}: DiscountCardDisclosureProps) => {
  const [isSelected, setIsSelected] = useState(false);
  const handleClick = useCallback(() => {
    setIsSelected(current => {
      const newValue = !current;
      if (newValue && onExpand) {
        onExpand();
      }
      return newValue;
    });
  }, [onExpand]);

  useEffect(() => {
    setIsSelected(isExpanded);
  }, [isExpanded]);

  return (
    <Styled.Disclosure isExpanded={isSelected}>
      <Styled.Field onChange={handleClick} slot="trigger">
        <Styled.CheckBox>
          <Check />
        </Styled.CheckBox>
        <Styled.Label>{label}</Styled.Label>
        <Styled.Icon>{icon}</Styled.Icon>
      </Styled.Field>
      <Styled.Panel>{children}</Styled.Panel>
    </Styled.Disclosure>
  );
};
